import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

import type { DistributableChange } from './useDistributableChanges';

export type DistributableTargetChange = {
  id: string;
  type: 'POLICY' | 'PREFACE';
  changeSets: { id: string }[];
  contentChange: 'CONTENT' | 'RELEASE_NOTE' | 'GUIDE_SHEET';
};

export type DistributableTarget = {
  organization: {
    name: string;
    type: 'CUSTOMER' | 'TEST';
    id: string;
  };
  manualId: string;
  manualTitle: string;
  distributableChanges: DistributableTargetChange[];
};

export default function useManageDistributableChanges() {
  const getDistributeTargets = async (
    manualId: string,
    data: DistributableChange[],
    callback?: (results: DistributableTarget[]) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse-manual-api/v1/manuals/${manualId}/child-candidate-change-sets`;
    await fetcher({
      url,
      method: 'post',
      body: {
        content: data.map((x) => ({
          id: x.id,
          type: x.type,
          contentChange: x.contentChange,
        })),
      },
    })
      .then((data) => {
        console.log('data', data);
        if (callback) callback(data.content);
      })
      .catch((err) => {
        console.warn('update err', err);
        if (onError) handleError(err, { onError });
      });
  };

  const distributeChanges = async (
    manualId: string,
    data: { id: string }[],
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse-manual-api/v1/manuals/${manualId}/issued-change-sets`;
    await fetcher({
      url,
      method: 'post',
      body: {
        changeSets: data.map((x) => ({
          id: x.id,
        })),
      },
    })
      .then((data) => {
        if (callback) callback();
      })
      .catch((err) => {
        console.warn('update err', err);
        if (onError) handleError(err, { onError });
      });
  };

  return {
    distributeChanges,
    getDistributeTargets,
  };
}
